import { getJoinedWordsWithComma } from 'utils';

export const getNudgesString = (fileNames: string[]) => {
  const length = fileNames?.length || 0;

  if (length > 3)
    return `${fileNames[0]}, ${fileNames[1]} and ${length - 2} more documents`;

  return getJoinedWordsWithComma(fileNames);
};
